import { SVGProps } from 'react';

export default function DecisioningIcon(props: SVGProps<SVGSVGElement>) {
  const { fill } = props;

  return (
    <svg
      style={{ width: 'inherit', height: 'inherit' }}
      viewBox="0 0 34 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M17 3.667c-.92 0-1.667.746-1.667 1.667 0 2.82-3.41 4.232-5.404 2.238A1.667 1.667 0 1 0 7.572 9.93c1.994 1.995.581 5.405-2.239 5.405a1.667 1.667 0 0 0 0 3.333c2.82 0 4.233 3.41 2.239 5.404a1.667 1.667 0 0 0 2.357 2.357c1.994-1.994 5.404-.582 5.404 2.239a1.667 1.667 0 1 0 3.333 0c0-2.82 3.41-4.233 5.405-2.239a1.667 1.667 0 1 0 2.357-2.357c-1.995-1.994-.582-5.404 2.238-5.404a1.667 1.667 0 1 0 0-3.334c-2.82 0-4.233-3.41-2.238-5.404a1.667 1.667 0 1 0-2.357-2.357c-1.995 1.994-5.405.582-5.405-2.239 0-.92-.746-1.666-1.666-1.666Zm-4.987 1.295a5 5 0 0 1 9.973 0 5 5 0 0 1 7.052 7.052 5 5 0 0 1 0 9.973 5 5 0 0 1-7.052 7.051 5 5 0 0 1-9.973 0 5 5 0 0 1-7.052-7.051 5 5 0 0 1 0-9.973 5 5 0 0 1 7.052-7.052Z"
        fill={fill}
      />
      <path
        d="M17 13.667a3.333 3.333 0 1 0 0 6.666 3.333 3.333 0 0 0 0-6.666Zm-4.714-1.38a6.667 6.667 0 1 1 9.428 9.428 6.667 6.667 0 0 1-9.428-9.429Z"
        fill={fill}
      />
    </svg>
  );
}
